import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { AvisoService } from '../../../core/service/aviso/aviso.service';

@Component({
  imports: [CommonModule],
  selector: 'app-upload-arquivo',
  templateUrl: './upload-arquivo.component.html',
  styleUrls: ['./upload-arquivo.component.css'],
})
export class UploadArquivoComponent {
  private readonly avisoService = inject(AvisoService);

  @Input() formatosAceitos: string[] = ['application/pdf', 'image/jpeg', 'image/png'];
  @Input() tamanhoArquivo = '';
  @Input() tamanhoMaximoMB = 5;
  @Input() alturaCard = '350px';
  @Input() textoTipoETamanho = 'Formatos aceitos: PDF, JPG, JPEG, PNG (máx. 5MB)';
  @Input() nomeArquivo = 'Selecione o arquivo';
  @Input() urlDocumentoSelecionado: string | null = null;
  @Output() arquivoSelecionado = new EventEmitter<File>();
  tipoArquivo = '';
  pdfSelecionado = false;
  documentoSelecionado: File | null = null;

  Upload(evento: Event) {
    const input = evento.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const tamanhoMB = file.size / (1024 * 1024);

    if (tamanhoMB > this.tamanhoMaximoMB) {
      input.value = '';
      this.avisoService.Erro(`Arquivo maior que o permitido (${this.tamanhoMaximoMB} MB).`);
      return;
    }

    if (!this.formatosAceitos.includes(file.type)) {
      this.avisoService.Erro(`Formato inválido!`);
      return;
    }

    this.documentoSelecionado = file;
    this.arquivoSelecionado.emit(this.documentoSelecionado);

    this.nomeArquivo = file.name;
    this.tipoArquivo = file.type;
    this.tamanhoArquivo = this.formatarTamanho(file.size);

    if (file.type.startsWith('image/')) {
      this.pdfSelecionado = false;
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        this.urlDocumentoSelecionado = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    } else if (file.type === 'application/pdf') {
      this.urlDocumentoSelecionado = null;
      this.pdfSelecionado = true;
    } else {
      this.urlDocumentoSelecionado = null;
      this.pdfSelecionado = false;
    }
  }

  formatarTamanho(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    else if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    else return `${(bytes / 1048576).toFixed(1)} MB`;
  }
}
